import type {
  DEFAULT_BRAND,
  SchemaKeys,
  SchemaType,
  StyleFullValue,
} from '@vedalib/editor/lib/brand'
import type { ElementSchemaType } from '@vedalib/editor/lib/brand'
import type React from 'react'

import type { IFieldConfig } from 'components/formKit'

export type BrandType = typeof DEFAULT_BRAND
export type ExtractStyle<S extends SchemaKeys> = SchemaType[S]['style']
export type ExtractFont<S extends SchemaKeys> = SchemaType[S]['font']
export type ExtractFeedback<S extends SchemaKeys> = SchemaType[S]['feedback']

export type ElementStyleCss<S extends ElementSchemaType | null = ElementSchemaType> = {
  [G in keyof S]: {
    [P in keyof S[G]]: P extends keyof React.CSSProperties
      ? React.CSSProperties[P]
      : S[G][P] extends { value?: infer V }
        ? V
        : unknown
  }
} & { root: React.CSSProperties; shell: React.CSSProperties }

export type ElementStyleValue<S extends ElementSchemaType | null = ElementSchemaType> = {
  [G in keyof S]: {
    [P in keyof S[G]]: S[G][P] extends { value?: infer V } ? V : unknown
  }
}

export type ElementFontCss<F extends ElementSchemaType | null = ElementSchemaType> = {
  [G in keyof F]: {
    [P in keyof F[G]]: P extends keyof React.CSSProperties
      ? React.CSSProperties[P]
      : F[G][P] extends Partial<StyleFullValue<infer V>>
        ? V
        : unknown
  }
}

export type ElementFontValue<F extends ElementSchemaType = ElementSchemaType> = {
  [G in keyof F]: {
    [P in keyof F[G]]: F[G][P]['value']
  }
}

export type ElementFeedbackCss<F extends ElementSchemaType | null = ElementSchemaType> = {
  [G in keyof F]: {
    [P in keyof F[G]]: P extends keyof React.CSSProperties
      ? React.CSSProperties[P]
      : F[G][P] extends Partial<StyleFullValue<infer V>>
        ? V
        : unknown
  }
}

export type ElementFeedbackValue<F extends ElementSchemaType = ElementSchemaType> = {
  [G in keyof F]: {
    [P in keyof F[G]]: F[G][P]['value']
  }
}

export type FieldsSchema<Schema = ElementSchemaType> = {
  [Tag in keyof Schema]: {
    [Style in keyof Schema[Tag]]: IFieldConfig
  }
}

export enum BrandFormEnum {
  TYPOGRAPHY = 'TYPOGRAPHY',
  FEEDBACK = 'FEEDBACK',
  STYLE = 'STYLE',
}
